import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import ApiService from "../../services/ApiService";
import Loader from "../../components/Loader";

const TABS = [
  { key: 'general',      label: 'General',              icon: 'bi-gear' },
  { key: 'map',          label: 'Google Map',           icon: 'bi-geo-alt' },
  { key: 'sms',          label: 'Whatsapp / SMS',       icon: 'bi-chat-dots' },
  { key: 'cancellation', label: 'Cancellation Settings', icon: 'bi-x-circle' },
];

const Setting = () => {
  const currency = process.env.REACT_APP_CURRENCY;
  const [isLoader, setIsLoader] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const [formData, setFormData] = useState({
    ios_version: '',
    android_version: '',
    payment_mode: '',
    service_charges: '',
    partner_commission: '',
    free_cancellation_hours: '',
    cancellation_charge_percentage: '',
    map_key: '',
    bwapi_key: '',
    bwapi_instance_id: '',
  });
  const [showMapKey, setShowMapKey] = useState(false);
  const [showBwapiKey, setShowBwapiKey] = useState(false);
  const [showBwapiInstanceId, setShowBwapiInstanceId] = useState(false);

  useEffect(() => {
    getSingleData();
  }, []);

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({ method: 'GET', url: 'admin/getSettings' });
      const data = response.data;
      if (data.status && data.data) {
        setFormData(prev => ({ ...prev, ...data.data }));
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({ method: 'POST', url: 'admin/updateSettings', data: formData });
      const data = response.data;
      if (data.status) toast.success(data.message);
      else toast.error(data.message);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      {/* Toolbar */}
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              App Settings
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/dashboard" className="text-muted text-hover-primary">Dashboard</a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">Settings</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Content */}
      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          {isLoader && !formData.ios_version ? (
            <div className="card">
              <div className="card-body p-9 text-center py-10">
                <Loader size={30} text="Loading" color="black" />
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="d-flex flex-column flex-lg-row">

                {/* Vertical tabs */}
                <div className="flex-column flex-lg-row-auto w-100 w-lg-250px mb-9 mb-lg-0 me-lg-9">
                  <div className="card">
                    <div className="card-body p-3">
                      <ul className="nav nav-flush flex-column fw-semibold">
                        {TABS.map(tab => (
                          <li className="nav-item" key={tab.key}>
                            <button
                              type="button"
                              onClick={() => setActiveTab(tab.key)}
                              className={`nav-link btn btn-flex btn-active-light-primary w-100 text-start mb-1 ${activeTab === tab.key ? 'active bg-light-primary text-primary' : 'text-gray-700'}`}
                            >
                              <i className={`bi ${tab.icon} fs-4 me-3`}></i>
                              <span className="fw-semibold">{tab.label}</span>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Tab panels */}
                <div className="flex-lg-row-fluid">
                  <div className="card">
                    <div className="card-body p-9">

                      {/* General */}
                      {activeTab === 'general' && (
                        <div className="row g-9">
                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">iOS Version</label>
                            <input type="text" name="ios_version" className="form-control form-control-solid"
                              value={formData.ios_version || ''} onChange={handleChange} placeholder="e.g. 1.0.0" />
                          </div>

                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Android Version</label>
                            <input type="text" name="android_version" className="form-control form-control-solid"
                              value={formData.android_version || ''} onChange={handleChange} placeholder="e.g. 1.0.0" />
                          </div>

                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Payment Mode</label>
                            <select name="payment_mode" className="form-select form-control-solid"
                              value={formData.payment_mode || ''} onChange={handleChange}>
                              <option value="">Select Mode</option>
                              <option value="live">Live</option>
                              <option value="test">Test</option>
                            </select>
                          </div>

                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Service Charges {currency && `(${currency})`}</label>
                            <input type="number" name="service_charges" className="form-control form-control-solid"
                              value={formData.service_charges || ''} onChange={handleChange}
                              placeholder="Enter service charges" min="0" step="0.01" />
                          </div>

                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Partner Commission (%)</label>
                            <input type="number" name="partner_commission" className="form-control form-control-solid"
                              value={formData.partner_commission ?? ''} onChange={handleChange}
                              placeholder="Enter commission percentage" min="0" max="100" step="0.01" />
                            <div className="form-text">Percentage deducted from each booking's subtotal as platform commission.</div>
                          </div>
                        </div>
                      )}

                      {/* Google Map */}
                      {activeTab === 'map' && (
                        <div className="row g-9">
                          <div className="col-md-12 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Google Maps API Key</label>
                            <div className="input-group">
                              <input type={showMapKey ? 'text' : 'password'} name="map_key"
                                className="form-control form-control-solid"
                                value={formData.map_key || ''} onChange={handleChange}
                                placeholder="Enter Google Maps API key" autoComplete="off"
                                style={{ fontFamily: 'monospace' }} />
                              <button type="button" className="btn btn-light"
                                onClick={() => setShowMapKey(prev => !prev)} tabIndex={-1}
                                title={showMapKey ? 'Hide' : 'Show'}>
                                <i className={`bi ${showMapKey ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                              </button>
                            </div>
                            <div className="form-text">Used for maps, geocoding and place lookups across the app.</div>
                          </div>
                        </div>
                      )}

                      {/* Whatsapp / SMS */}
                      {activeTab === 'sms' && (
                        <div className="row g-9">
                          <div className="col-md-12 fv-row">
                            <label className="fs-6 fw-semibold mb-2">BWAPI Key</label>
                            <div className="input-group">
                              <input type={showBwapiKey ? 'text' : 'password'} name="bwapi_key"
                                className="form-control form-control-solid"
                                value={formData.bwapi_key || ''} onChange={handleChange}
                                placeholder="Enter BWAPI key" autoComplete="off"
                                style={{ fontFamily: 'monospace' }} />
                              <button type="button" className="btn btn-light"
                                onClick={() => setShowBwapiKey(prev => !prev)} tabIndex={-1}
                                title={showBwapiKey ? 'Hide' : 'Show'}>
                                <i className={`bi ${showBwapiKey ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                              </button>
                            </div>
                            <div className="form-text">API key used to send Whatsapp / SMS notifications.</div>
                          </div>
                          <div className="col-md-12 fv-row">
                            <label className="fs-6 fw-semibold mb-2">BWAPI Key</label>
                            <div className="input-group">
                              <input type={showBwapiInstanceId ? 'text' : 'password'} name="bwapi_instance_id"
                                className="form-control form-control-solid"
                                value={formData.bwapi_instance_id || ''} onChange={handleChange}
                                placeholder="Enter BWAPI instance ID" autoComplete="off"
                                style={{ fontFamily: 'monospace' }} />
                              <button type="button" className="btn btn-light"
                                onClick={() => setShowBwapiInstanceId(prev => !prev)} tabIndex={-1}
                                title={showBwapiInstanceId ? 'Hide' : 'Show'}>
                                <i className={`bi ${showBwapiInstanceId ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                              </button>
                            </div>
                            <div className="form-text">API key used to send Whatsapp / SMS notifications.</div>
                          </div>
                        </div>
                      )}

                      {/* Cancellation Settings */}
                      {activeTab === 'cancellation' && (
                        <div className="row g-9">
                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Free Cancellation Window (hours)</label>
                            <input type="number" name="free_cancellation_hours" className="form-control form-control-solid"
                              value={formData.free_cancellation_hours ?? ''} onChange={handleChange}
                              placeholder="e.g. 24" min="0" step="1" />
                            <div className="form-text">Cancellations made at least this many hours before the event are fully refunded.</div>
                          </div>

                          <div className="col-md-6 fv-row">
                            <label className="fs-6 fw-semibold mb-2">Cancellation Charge (%)</label>
                            <input type="number" name="cancellation_charge_percentage" className="form-control form-control-solid"
                              value={formData.cancellation_charge_percentage ?? ''} onChange={handleChange}
                              placeholder="e.g. 20" min="0" max="100" step="0.01" />
                            <div className="form-text">Percentage of the booking total deducted when a user cancels inside the free window.</div>
                          </div>

                          <div className="col-md-12">
                            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                              <i className="bi bi-info-circle fs-2hx text-primary me-4"></i>
                              <div className="d-flex flex-stack flex-grow-1">
                                <div className="fw-semibold">
                                  <div className="fs-6 text-gray-700">
                                    Example: with a {formData.free_cancellation_hours || 0}h free window and a {formData.cancellation_charge_percentage || 0}% charge,
                                    a user cancelling within {formData.free_cancellation_hours || 0} hours of the event is charged {formData.cancellation_charge_percentage || 0}% of the booking total; earlier cancellations are free.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Actions */}
                      <div className="d-flex justify-content-end mt-9">
                        <button type="submit" className="btn btn-base" disabled={isLoader}>
                          <span hidden={isLoader}>Save Settings</span>
                          {isLoader && <Loader size={20} text="Saving" />}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Setting;
